import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

@Pipe({ name: 'formatDateFull' })
export class FormatDateFullPipe implements PipeTransform {
    transform(value: any): string {
        return moment(value).format('dddd DD MMM YYYY')
    }
}
